import React from 'react';
import { Button } from '@mui/material';
import { usePermissions, useTranslate } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import { hasPermission } from '../../utils/hasPermission';

export const KioskTransactionLink = ({ transactionId }: { transactionId: string | null }) => {
  const translate = useTranslate();
  const navigate = useNavigate();
  const { permissions } = usePermissions();
  if (transactionId === null || !hasPermission(permissions as string[] | null | undefined, 'kiosk-transactions:read:all')) return null;
  return (
    <Button
      size="small"
      variant="text"
      onClick={(event) => {
        event.stopPropagation();
        navigate(`/kiosk-transactions/${transactionId}/show`);
      }}
    >
      {translate('resources.kiosk-transactions.sessionLink')}
    </Button>
  );
};
